import script from "./Copyright.vue?vue&type=script&setup=true&lang=js"
export * from "./Copyright.vue?vue&type=script&setup=true&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=68a713a0&scoped=true&lang=scss"

import exportComponent from "D:\\citbooks-fore-end20251021\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a713a0"]])

export default __exports__